export const ALL_TEMPLATES = 'ALL_TEMPLATES'
export const CATEGORY_TEMPLATES = 'CATEGORY_TEMPLATES'
export const SIMILAR_CATEGORY_TEMPLATES = 'SIMILAR_CATEGORY_TEMPLATES'

export const TEMPLATES_NULL = 'TEMPLATES_NULL'
export const GET_TEMPLATE_DETAIL= 'GET_TEMPLATE_DETAIL'
export const FORM_CREATED_VIA_TEMPLATE = 'FORM_CREATED_VIA_TEMPLATE'

export const FORM_VIA_TEMPLATE_AFTER_AUTH = 'FORM_VIA_TEMPLATE_AFTER_AUTH'